module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SkwNIx/media/FC-9781638298533.jpg?1684515200177",
      "alt": "This image is the cover for the book Move Forward"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Move Forward\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('em', [_vm._v("Move Forward")]), _vm._v(" is a guide for those feeling uncertain about their future. The constant demands of the world can leave us feeling drained and disconnected from our true selves. This book offers a new approach to finding hope and purpose, helping readers rediscover their strengths, passions, and dreams. Through practical strategies and a unique STAR pathway, "), _c('em', [_vm._v("Move Forward")]), _vm._v(" empowers readers to take control of their lives and create a fulfilling future.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John R. Christensen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("John R. Christensen")])]), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v(" has spent his professional life as an Executive Life Strategist with a broad base of international clientele. John has established a reputation as a thought leader through his cutting-edge coaching process. As an author, John’s writing grasps the urgency of vital words and ideas in all forms of communication. The themes of leadership, empowerment and self-development inform both his critical and creative writing. He resides with his wife Hazel, in Burlington, Ontario, Canada.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Roger J. Preis")])]), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v(" is President of RPE Career Dynamics specializing in executive coaching, career & life/work planning, organizational development and management consulting. Previously, Roger was President of Robert Half International Inc. in Connecticut, and the Greater New York area. He has also held corporate positions in recruitment, employment/staffing and employee relations at Chesebrough-Pond’s/Unilever. Roger was also on the faculty at the University of Connecticut.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Roger serves in non-profit board leadership roles, including the Boys & Girls Club in Vermont and previously, VNA & Hospice Care in Connecticut. Roger received the prestigious national Dependable Leader award from Boys & Girls Clubs of America. Roger has also been a two-time recipient of the Boys & Girls Clubs of America’s National Service Award.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0